import React from 'react';
import styles from './Table.module.css';

// Resumen "Mostrando X–Y de Z <sustantivo>" a partir del meta del paginador de Laravel
const TableCaption = ({ pagination, noun = 'registros' }) => {
  if (!pagination?.total) return null;
  const { from, to, total } = pagination;
  return (
    <p className={styles.tableCaption}>
      {from && to ? `Mostrando ${from}–${to} de ${total} ${noun}` : `${total} ${noun}`}
    </p>
  );
};

export default TableCaption;
